import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';
import { IConnectedApplicationSecretType } from '../types/ConnectedApplicationType';
import { API_VERSION, DIRECT_TRUST_PATH } from './RestApiConstants';

export interface CreateConnectedApplicationSecretResult {
    connectedApplicationSecret: IConnectedApplicationSecretType;
}

function createConnectedApplicationsSecretRequestConfig(appId: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'POST',
    endpoint: `${DIRECT_TRUST_PATH}/${appId}/secrets`,
    serverWideRequest: false
  };
}

export function callCreateConnectedApplicationsSecret(appId: string): Promise<CreateConnectedApplicationSecretResult> {
  return makeJsonRestApiRequest<void, CreateConnectedApplicationSecretResult>({
    config: createConnectedApplicationsSecretRequestConfig(appId),
    request: null,
  });
}